/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import Box from "@mui/material/Box";
import { Button } from "@forge/common";
import Drawer from "@mui/material/Drawer";
import * as React from "react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import RestartAltIcon from "@mui/icons-material/RestartAlt";

import {
  AccordionItem,
  FilterIcon,
  Label,
  Checkbox as ForgeCommonCheckbox,
  Button as ForgeCommonButton,
  CloseIcon as ForgeCommonCloseIcon,
} from "@forge/common";
import { RootState } from "../../../store";
import type { Role, WrapperUserPermissions } from "../../../models";
import getRelevantUsersBasedOnPersona from "../../../utils/methods/getRelevantUsersBasedOnPersona";
type Anchor = "top" | "left" | "bottom" | "filter";

export default function TemporaryDrawerForOrgUser({
  isFilterDisabled,
  filteringGroup,
  onFilteringCriteriaChange,
  hierarchicalOrganizationwKey,
  comp,
  gridData,
}: {
  isFilterDisabled?: boolean;
  filteringGroup: any;
  onFilteringCriteriaChange: any;
  hierarchicalOrganizationwKey?: any;
  comp?: any;
  gridData?: any;
}) {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    filter: false,
  });

  const [selectedOptions, setSelectedOptions] =
    useState<Array<Role>>(filteringGroup);
  // const [selectedFilterOptions, setSelectedFilterOptions] = useState<Role[]>();
  const [clearFilter, setClearFilter] = useState<boolean>(false);

  const ListofRoles = useSelector((state: RootState) =>
    state.user.users.map((user) => user.roles)
  );

  
  const userPermissions: WrapperUserPermissions = useSelector(
    (state: RootState) => state.user.userPermissions
  );
  
  const [roleCounts, setRoleCounts] = useState<any>({});

  useEffect(() => {
    setSelectedOptions(filteringGroup);
  }, [filteringGroup]);

  //on change of user filter
  // istanbul ignore next
  // If the checkbox is checked, add the option to the selectedOptions array
  const handleCheckboxChange = (option: Role, event: any) => {
    if (event.target.checked) {
      setSelectedOptions([...selectedOptions, option]);
    } else {
      // If the checkbox is unchecked, remove the option from the selectedOptions array
      setSelectedOptions(selectedOptions.filter((item) => item !== option));
    }
  };

  // On handle of cancel
  // istanbul ignore next
  // set it to empty array
  const handleCancel = () => {
    setSelectedOptions([]);

    setState({ top: false, left: false, bottom: false, filter: false });
  };

  // On handle of cancel
  // istanbul ignore next
  // Clear all
  const handleClear = () => {
    setSelectedOptions([]);
    setClearFilter(true);
  };

  // on submit of submit
  // istanbul ignore next
  const handleSubmit = () => {
    onFilteringCriteriaChange(selectedOptions);
    setState({ ...state, filter: false });
  };

  const toggleDrawer = (anchor: Anchor, open: boolean) => () => {
    setState({ ...state, [anchor]: open, filter: true });
  };

  const list = (anchor: Anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    ></Box>
  );

  /**For calculating num of users of the role */
  useEffect(() => {
    // Extract and flatten the roles array
    const persona = userPermissions.user_persona;

    const data: any = gridData?.length > 0 ? getRelevantUsersBasedOnPersona(gridData, persona) : [];

    const flattenedRoles: any = data?.flatMap((item: any) => item.roles);

    // Count the occurrences of each roleId
    const roleCounts = flattenedRoles?.reduce(
      (
        roleCountAccumulator: { [x: string]: any },
        role: { roleId: string | number }
      ) => {
        roleCountAccumulator[role.roleId] =
          (roleCountAccumulator[role.roleId] || 0) + 1;
        return roleCountAccumulator;
      },
      {}
    );

    setRoleCounts(roleCounts);
  }, [gridData]);

  return (
    <div>
      {(["filter"] as const).map((anchor) => (
        <div key={anchor}>
          <Button
            disabled={isFilterDisabled}
            data-testid="filterbtn"
            className="filter-Icon"
            onClick={toggleDrawer(anchor, true)}
            aria-label="filter"
            variant="tertiary"
          >
            <FilterIcon strokeWidth={2} />
            {/* <div style={{ textTransform: "capitalize" }}>{anchor}</div> */}
          </Button>
          <Drawer
            anchor={"right"}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            variant="temporary"
          >
            <div className="header-Filter">
              <Label className="p-l10 m-b0 p-b0">FILTER</Label>
              {/* // Close Icon */}
              <ForgeCommonButton
                icon={<ForgeCommonCloseIcon strokeWidth={2} />}
                iconPosition="left"
                label="Schedule"
                onClick={handleCancel}
                data-testid="handleCancel_Close"
                size="regular"
                variant="quiet-secondary"
                className="forgeCommonIconBtn"
                aria-label="Close"
              />
            </div>

            <div className="header-Filter">
              <Label className="p-l10 p-b0 m-b0">Filter By Roles </Label>

              <ForgeCommonButton
                variant="quiet-primary"
                className="p-l10"
                data-testid="handleClearButton"
                onClick={handleClear}
                icon={<RestartAltIcon />}
                aria-label="Clear all"
              >
                Clear all
              </ForgeCommonButton>
            </div>

            <AccordionItem title={`Roles`} id="Roles">
              <div className="roleDiv">
                {/* {ListofRoles?. */}
                {/* {[
                  [
                    { roleId: "1", name: "Admin" },
                    { roleId: "2", name: "User" },
                  ],
                  [
                    { roleId: "3", name: "Guest" },
                    { roleId: "4", name: "Member" },
                  ],
                  [
                    { roleId: "5", name: "Owner" },
                    { roleId: "6", name: "Contributor" },
                  ], 
                ]*/}
                {ListofRoles?.flat()
                  .filter((value, index, self) => self.indexOf(value) === index)
                  ?.filter(
                    (item, i, ar) =>
                      ar.map((x) => x.roleId).indexOf(item.roleId) === i
                  )
                  .map((option: any) => (
                    roleCounts?.[option.roleId] > 0 && (
                    <div key={option.name} className="optionsCheck">
                      <ForgeCommonCheckbox
                        id={`user-${option.name}`}
                        aria-label="User"
                        checked={selectedOptions
                          .map((x) => x.name)
                          .includes(option.name)}
                        onChange={(event: any) =>
                          handleCheckboxChange(option, event)
                        }
                        className="Check"
                      />
                      <div className="roleName">{option.name}</div>
                      {`(${roleCounts?.[option.roleId] ?? 0})`}
                    </div>)
                  ))}
              </div>
            </AccordionItem>

            <div className="footer-filter-org-user-popup p-5">
              <ForgeCommonButton
                data-testid="handleCancelButton"
                onClick={handleCancel}
                variant="quiet-primary"
              >
                Cancel
              </ForgeCommonButton>

              <ForgeCommonButton
                data-testid="submit_btn"
                onClick={handleSubmit}
              >
                Show Results
              </ForgeCommonButton>
            </div>

            {list(anchor)}
          </Drawer>
        </div>
      ))}
    </div>
  );
}
